export const InitialShowOrgFilterState = {
  organisationId: new Map<number, boolean>(),
  selectedOrganisations: {},
};

export enum FilterKeys {
  organisation = 'filter_org',
  region = 'filter_region',
  department = 'filter_department',
  gender = 'filter_gender',
  age = 'filter_age',
}

export enum SelectedBenchmark {
  GLOBAL = 0,
  INDUSTRY = 1,
}
